/* eslint-disable no-template-curly-in-string */
import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    explore: 'Explore',
    pool: ' / {assetNameSecond}',
    assets: 'Assets',
    protocol: 'Protocol',
    network: 'Network',
    title: 'DeFi Integrations',
    comingSoon: 'Coming soon',
  },
};
